import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { CrudCreateComponent } from '../../../shared/components/crud/create/create.component';
import { FormField } from '../../../constants/form.constants';
@Component({
  selector: 'app-competencias-create',
  templateUrl: './competencia-create.html',
  styleUrl: './competencias-create.scss',
  imports: [CrudCreateComponent],
})
export class CompetenciasCreate {
fields : {[name: string]:FormField} = {
    descripcion: {
      label: 'Descripción',
      type: 'text',
      position: 1,
      validations: [Validators.required]
    },
    caracter: {
      label: 'Carácter',
      type: 'select',
      position: 2,
    },
    observacion: {
      label: 'Observación',
      type: 'textarea',
      position: 4,
      validations: [Validators.required,Validators.minLength(2)]
    },
    fecha: {
      label: 'Fecha Inicio',
      type: 'date',
      position: 3,
      validations: [Validators.required]
    },
  }
  @Input() title : string = ''
}



